import React from 'react';
import PropTypes from 'prop-types';

const PreviewButton = props => (
  props.isVisible ?
  (
    <button
      id={props.id}
      className={props.className}
      onClick={props.click}
    >{props.text}</button>
  ) :
  null
);

PreviewButton.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  click: PropTypes.func,
  text: PropTypes.string,
  isVisible: PropTypes.bool,
};

PreviewButton.defaultProps = {
  id: '',
  className: '',
  click: () => {},
  text: '',
  isVisible: true,
};

export default PreviewButton;



// WEBPACK FOOTER //
// ./src-react/SignatureManager/PreviewButton.jsx